import { TSelectionState } from "../Tables/TableDestino";

type TCarteraIsinWeight = {
    isin: string;
    weight: number;
}

export type TDiversificationCall = {
    cartera: TCarteraIsinWeight[];
}

type TDataToDivesificationCallProps = {
    fundsData: TSelectionState;
    isOrigen: boolean
}

export const DataToDivesificationCall = ({ fundsData, isOrigen }: TDataToDivesificationCallProps): TDiversificationCall => {
    const result: TDiversificationCall = { cartera: []};
    
    Object.entries(fundsData).forEach(([_, value])=> {
        const { checked, data } = value;

        const isinRelated = isOrigen
            ? data.originalIsin
            : checked
                ? data.destinyIsin || data.originalIsin    
                : data.originalIsin;

        const weightRelated = (isOrigen ? data.originalWeight : data.destinyWeight) / 100;

        result.cartera.push({
            isin: isinRelated,
            weight: weightRelated
            })
    });

    return result;
};